export default ['"', "'", '!', '.', '?'];
